// ABOUTME: Route for /facility/locations/$locationId.
// ABOUTME: Renders the FacilityOverviewPage component.

import FacilityOverviewPage from "@/components/facility/FacilityOverviewPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/facility/locations/$locationId",
)({
  component: FacilityOverviewPage,
});
